import {AdvertApiResponse, ApiResponse} from "../types/ApiResponse";
import {deserialize} from "deserialize-json-api";
import {Advert} from "../types/Advert";
import {RequestParams} from "./RequestParams";
import {Make} from "../types/Make";
import {Location} from "../types/Location";

const token = (window as any).apiToken;
const API_URL = "https://choosemycar.com/api";

const apiRequest = async (endpoint: string, method: string = "GET") => {
    return await fetch(`${API_URL}${endpoint}`, {
        method: method,
        headers: {
            "Accept": "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            "Authorization": "Bearer " + token,
        }
    });
}

export async function fetchAdverts(params: RequestParams): Promise<AdvertApiResponse<Advert>> {
    const res = await apiRequest(`/adverts/search${params.toApiString()}`)
    return deserialize(await res.json());
}

export async function fetchMakes(): Promise<ApiResponse<Make>> {
    const res = await apiRequest(`/makes?filter[standard]=true`);
    return deserialize(await res.json());
}

export async function fetchLocations(): Promise<ApiResponse<Location>> {
    const res = await apiRequest(`/locations`);
    return deserialize(await res.json());
}
